/** Configuración de la empresa (T072 · US3). */
import { createFileRoute } from '@tanstack/react-router';

import { CompanySettingsPage } from '../../features/settings/company-settings-page';

export const Route = createFileRoute('/_app/configuracion')({
  component: CompanySettingsPage,
});
